import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core';
import { shallowEqual, useSelector } from 'react-redux';
import { RootState } from 'state/store';

const Wrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: ${(props) => props.theme.spacing(0, 0, 1, 0)};
`;

const InboundCallGreeting = () => {
  const { greeting, personaName, personaTeamName } = useSelector(
    (state: RootState) => ({
      greeting: state.lead.entity?.agent?.agentSetting?.settings?.greeting,
      personaName: state.lead.entity?.agent?.personaName,
      personaTeamName: state.lead.entity?.agent?.personaTeamName,
    }),
    shallowEqual
  );
  const defaultGreeting = `Thank you for calling ${personaTeamName}, this is ${personaName} how can I help you?`;

  return (
    <Wrapper>
      <Typography>{greeting || defaultGreeting}</Typography>
    </Wrapper>
  );
};

export default InboundCallGreeting;
